import { ApolloError } from '@apollo/client';

import { useCompanyCreditCards } from '../useCompanyCreditCards';

interface ShouldSeeCutCardsScreenResult {
  shouldSeeCutCardsScreen: boolean;
  loading: boolean;
  error?: ApolloError;
}

export const useShouldSeeCutCardsScreen = (): ShouldSeeCutCardsScreenResult => {
  const { creditCards, error, loading } = useCompanyCreditCards();

  return {
    error,
    loading,
    shouldSeeCutCardsScreen: creditCards.length > 0,
  };
};
